import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { downloadBlob } from 'common/utils';
import { getZipFile } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Files cannot be downloaded, please try again later.');
  console.error('Error while downloading files', error);
};

export const useGetZipFileMutation = () =>
  useMutation<unknown, { id: string }>({
    defaultMutateOnError,
    async mutationFn({ id }) {
      const response = await getZipFile(id);
      downloadBlob(new Blob([response.data]), 'Attachments.zip');
    },
  });
